import React from "react";
import { observer } from "mobx-react";
import copilotStore from "Stores/copilotStore";

const formatWhen = ts => {
  if (!ts) return "";
  const then = new Date(ts);
  const now = new Date();
  const sameDay = then.toDateString() === now.toDateString();
  if (sameDay) {
    return then.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  }
  return then.toLocaleDateString([], { month: "short", day: "numeric" });
};

const HistoryDrawer = observer(() => {
  if (!copilotStore.historyOpen) return null;

  return (
    <div className="copilotHistory">
      <button
        type="button"
        className="copilotHistory__newChat"
        disabled={copilotStore.streaming}
        onClick={copilotStore.newChat}
      >
        <i className="material-icons-outlined">add</i>
        <span>New chat</span>
      </button>
      <div className="copilotHistory__label">Recent</div>
      <div className="copilotHistory__list">
        {!copilotStore.conversations.length && (
          <div className="copilotHistory__empty">No conversations yet</div>
        )}
        {copilotStore.conversations.map(item => (
          <div
            key={item.id}
            className={`copilotHistory__item ${
              item.id === copilotStore.conversationId ? "active" : ""
            }`}
            onClick={() => copilotStore.loadConversation(item.id)}
          >
            <div className="copilotHistory__itemMeta">
              <span className="copilotHistory__itemTitle">
                {item.title || "New conversation"}
              </span>
              <span className="copilotHistory__itemWhen">
                {formatWhen(item.ts)}
              </span>
            </div>
            <i
              className="material-icons-outlined copilotHistory__delete"
              title="Delete conversation"
              onClick={event => {
                event.stopPropagation();
                copilotStore.deleteConversation(item.id);
              }}
            >
              delete
            </i>
          </div>
        ))}
      </div>
    </div>
  );
});

export default HistoryDrawer;
